import { Accordion } from '../components/Accordion';

export class FaqPage {
  init(): void {
    Accordion.initAll('.js-accordion');
  }
}
